import dl from "./device-language";

function isEven(value) {
    return (Number(value) % 2 === 0) ? true : false;
}

function shouldDisplayCta(type, apiResponse) {
    if (type === "r" || type === "h" || type === "s") {
        return apiResponse.tableservice.active;
    } else if ((type === "d" || type === "t") && (Boolean(apiResponse.delivery.active) === true || Boolean(apiResponse.takeaway.active) === true)) {
        return true;
    } else if (type === "b") {
        return true;
    }
}

function shouldDisplayDishDetails(dish) {
    return dish ?
        (dish.hasOwnProperty("description") && ("" !== dish.description)) ||
        (dish.hasOwnProperty("ingredients") && (0 < dish.ingredients.length)) :
        false;
}

function shouldDisplayDrinkDetails(drink) {
    return drink ?
        (drink.hasOwnProperty("description") && ("" !== drink.description)) ||
        (drink.hasOwnProperty("image_path") && ("" !== drink.image_path)) :
        false;
}

function shouldDisplayRestaurantCoverCharge(restaurant, type) {
    return restaurant ?
        restaurant.hasOwnProperty("cover_charge") && Boolean(restaurant.cover_charge) && type === "r" :
        false;
}

function shouldDisplayPrice(item, field) {
    return item ?
        item.hasOwnProperty(field) && item[field] :
        false;
}

function shouldDisplayPayments(restaurant) {
    let check = restaurant.hasOwnProperty("payments") && restaurant.payments
        .filter(payment => "cash" !== payment.name)
        .filter(payment => payment.active === true);

    return Boolean(check.length);
}

function shouldDisplayPaymentsV2(restaurant, type) {
    if (type === "restaurant") {
        type = "tableservice";
    }

    let check = restaurant.orders[type].hasOwnProperty("payment_methods") && restaurant.orders[type].payment_methods
        .filter(payment => "cash" !== payment.name);

    return Boolean(check.length);
}

function shouldDisplayPaymentsButton(restaurant, name) {
    if (restaurant) {
        if (restaurant.hasOwnProperty("payments")) {
            let check = restaurant.payments.filter(payment => payment.name === name);

            if (check.length > 0) {
                return check[0].active;
            }
        }
    }
    return false;
}

function shouldDisplayPaymentsButtonV2(restaurant, name, type) {
    if (type === "restaurant") {
        type = "tableservice";
    }

    if (restaurant) {
        if (restaurant.orders[type].hasOwnProperty("payment_methods")) {
            let check = restaurant.orders[type].payment_methods.filter(payment => payment.name === name);
            if (check.length > 0) {
                return true;
            }
        }
    }
    return false;
}

function shouldDisplayFilterIcon(element) {
    if (element && element.hasOwnProperty("icon") && element.icon !== "") { // element.icon != "" && element.icon != null - 0 != "" gives false
        return true;
    }
}

function shouldDisplayIndecisiTab(restaurant) {
    return !["IJwpJoOWW"].includes(restaurant.token);
}

function capitalize(s) {
    if (typeof s !== "string") {
        return "";
    };
    return s.charAt(0).toUpperCase() + s.slice(1);
}

function cleanPrice(price) {
    price = Number(price);
    return price && !isNaN(price) ? price : "";
}

function formatPrice(price, risId, locale) {
    let options = {
        "style": "currency",
        "currency": (risId && Number(risId) === 14926) ? "AED" : "EUR",
        "minimumFractionDigits": 2,
    };

    return new Intl.NumberFormat(locale ? locale : dl.getDeviceLanguage(), options).format(price);

}

function formatUrl(url, obj) {
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const token = `:${key}`;
            url = String(url).replace(token, obj[key]);
        }
    }
    return url;
}

function formatIngredients(ingredients) {
    let mapped = ingredients.map((ingredient) => {
        let name = ingredient.name;

        name += ingredient.has_allergens ?
            " (" + ingredient.allergens.map(allergen => allergen.name).join(", ") + ")" :
            "";

        return capitalize(name);
    });

    return mapped.join(", ");
}

function formatDrinkName(drink) {
    let name = capitalize(drink.name);

    name += !!drink.cellar ? ` (${drink.cellar})` : "";
    name += !!drink.year ? ` (${drink.year})` : "";

    return name;
}

function formatDescription(item) {
    let originalDescription = item.hasOwnProperty("description") ?
        String(item.description) : "";

    return originalDescription.length > 100 ?
        originalDescription.substr(0, 97) + "..." :
        originalDescription;
}

function formatMotuekaDescription(description) {
    return description.split(/-/gi);
}

function truncate(text, length) {
    if (text.length > length) {
        return text.substr(0, length) + "...";
    } else {
        return text;
    }
}

function getDayOfWeek(Day) {
    const Days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
    return Days.indexOf(Day);
}

function shiftTime(dt, minutesShift) {
    let date = new Date(dt.getTime() + minutesShift * 60000);
    let hours = date.getHours();
    let minutes = date.getMinutes();
    if (minutes < 10) {
        minutes = "0" + (minutes.toString());
    }
    return { hours, minutes };
}

function formatIsoTime(dt) {
    let aux = dt.toISOString();
    let newTime = [];
    let twotimes = 0;
    for (let i = 0; i < aux.length && twotimes < 2; i++) {
        newTime.push(aux[i]);
        if (aux[i] === ":") {
            twotimes = twotimes + 1;
        }
        if (Number(twotimes) === 2) {
            newTime.pop();
        }
    }
    newTime = newTime.join("");

    return newTime;
}

function shouldShowListBasedOnTimetables(timetables) {
    if (timetables.length === 0) {
        return false;
    }

    const now = new Date();
    const currentDay = now.toLocaleDateString('en-US', { weekday: 'short' }).toUpperCase();

    const baseDate = now.toISOString().split('T')[0]; // YYYY-MM-DD
    const currentDateTime = new Date(`${baseDate}T${now.toTimeString().slice(0, 8)}`);


    const todayTimetables = timetables.filter(
        timetable => timetable.day_of_week === currentDay
    );

    return todayTimetables.some(timetable => {
        const openDateTime = new Date(`${baseDate}T${timetable.open}:00`);
        let closeDateTime = new Date(`${baseDate}T${timetable.close}:00`);
        return currentDateTime >= openDateTime && currentDateTime <= closeDateTime;
    });
}

function shouldShowList(timetables, token, hasOrders, type) {
    if (!hasOrders) {
        return false;
    }

    if (token === "uDLyzSMf1" && type === "r") {
        return shouldShowListBasedOnTimetables(timetables);
    }

    return true;
}

function getDeliveryRangeCost(restaurant) {
    let minCost, maxCost = null;

    const distanceFares = restaurant.orders.delivery.distance_fares.map((distanceRange, i) =>
        distanceRange.cost_increase
    );

    if (distanceFares.length > 0) {
        minCost = Math.min.apply(Math, distanceFares);
        maxCost = Math.max.apply(Math, distanceFares);
    }

    return { minCost, maxCost };
}

async function setSearchedItems(restaurant, searchedPyload) {
    // !!c'è del torbido attorno a questa funzione
    restaurant.filtered_items = searchedPyload;
    if (searchedPyload.dishes === null || Number(searchedPyload.dishes) === 0) { // undefined == null (?)
        delete restaurant.filtered_items;
    }
}

async function formatGmapsStreet(address_components, coordinates) {
    const componentForm = {
        street_number: "short_name",
        route: "long_name",
        locality: "long_name",
        administrative_area_level_1: "short_name",
        country: "long_name",
        postal_code: "short_name",
    };
    const addressObject = {
        streetNumber: "",
        streetName: "",
        cityName: "",
        stateAbbr: "",
        zipCode: "",
        coordinates: { latitude: coordinates.lat, longitude: coordinates.lng }
    };

    for (let i = 0; i < address_components.length; i++) {
        const addressType = address_components[i].types[0];
        if (componentForm[addressType]) {
            switch (addressType) {
                case "street_number":
                    addressObject.streetNumber = address_components[i].long_name;
                    break;
                case "route":
                    addressObject.streetName = address_components[i].long_name;
                    break;
                case "locality":
                    addressObject.cityName = address_components[i].long_name;
                    break;
                case "administrative_area_level_1":
                    addressObject.stateAbbr = address_components[i].short_name;
                    addressObject.state = address_components[i].long_name;
                    break;
                case "postal_code":
                    addressObject.zipCode = address_components[i].long_name;
                    break;
                case "country":
                    addressObject.countryAbbr = address_components[i].short_name;
                    addressObject.country = address_components[i].long_name;
                    break;
                default:
                    break;
            }
        }
    }
    return addressObject;
}

function formatPercentageToPrice(percentage, total) {
    const x = (total * percentage) / 100;
    return total - x;
}

function replacer(matched) {
    return `<a className="underline" href="${matched}" target="_blank" rel="noopener noreferrer">${matched}</a>`;
}

function legacyFilterFormatter(cia) {
    let { needs, demands } = cia;

    const dietsMap = { "1": 3, "2": 6, "3": 20, "4": 12, "5": 13, "6": 14, "7": 19 };
    const allergiesMap = { "1": 15, "2": 16, "3": 14, "4": 17, "5": 3, "6": 4, "7": 5, "8": 6, "9": 7, "10": 13, "11": 8, "12": 18, "13": 19, "14": 11, "15": 12 };

    return {
        allergies: needs.filter(need => "allergen" === need.type).map(need => ({ label: need.name, value: allergiesMap[String(need.id)] })),
        diets: needs.filter(need => "diet" === need.type).map(need => ({ label: need.name, value: dietsMap[String(need.id)] })),
        foods: demands.filter(demand => "aversion" === demand.type).map(demand => ({ label: demand.name, value: demand.id })),
    };
}

function chooseIconText(path) {
    let store = {
        "images/icons/menu/ic_tick_green.png": "piatto privo di glutine",
        "images/icons/menu/ic_cross_gray.png": "allergene rilevato",
        "images/icons/menu/ic_cross_orange.png": "allergene rilevato",
        "images/icons/menu/ic_tick_gray.png": "alimento non gradito",
        "images/icons/menu/ic_triangle_gray.png": "intolleranza alimentare",
        "images/icons/menu/ic_triangle_orange.png": "intolleranza alimentare",
        "images/icons/menu/ic_cross_yellow.png": "contaminazioni rilevate",
    };

    return store[path];
}

function mcmUrl(type, token) {
    let url = new URL("https://mycontactlessmenu.mycia.it");
    url.pathname = `${type}/q/${token}`;
    return url.toString();
}

function loginUrl(type, token) {
    let url = new URL(process.env.REACT_APP_LOGIN_DOMAIN);
    url.pathname = "login";
    url.searchParams.append("redirect", mcmUrl(type, token));
    return url.toString();
}

function shouldDisplayCustomBanner(id) {
    const validIDs = [
        15317, 10011, 13631, 8383, 11322, 7695, 8740, 7268, 6844, 7500,
        11327, 13041, 6811, 14999, 13921, 10155, 8960, 10281, 10294, 6887,
        13890, 10453, 10199, 6684, 6605, 7118, 6927, 6869, 7302, 6619, 7245,
        6664, 7353, 7057, 9690, 7253, 11554, 6658, 6788, 7292, 6493, 6751,
        9345, 10134, 7105, 7424, 7237, 7158, 6733, 7302
    ];

    return validIDs.includes(id);
}

function generateRandomID(string) {
    return string + (Date.now().toString(36) + "_" + Math.random().toString(36).substr(-5)).toLowerCase();
}

function getConsumeTime(restaurantToken) {
    const now = new Date();
    const minutesNow = now.getHours() * 60 + now.getMinutes();

    const timeRanges = {
        fWQCgyh1F: { lunch: 7 * 60, dinner: 17 * 60 + 30 },       // 07:00 - 17:30
        CBfANv9M6: { lunch: 7 * 60, dinner: 18 * 60 },            // 07:00 - 18:00
        uDmsbbYYS: { lunch: 7 * 60, dinner: 18 * 60 },            // 07:00 - 18:00
        JnsoKEb1X: { lunch: 7 * 60, dinner: 15 * 60 },            // 07:00 - 15:00
        a1b2c3d4e: { lunch: 7 * 60, dinner: 14 * 60 }             // 07:00 - 14:00
    };

    if (timeRanges.hasOwnProperty(restaurantToken)) {
        const { lunch, dinner } = timeRanges[restaurantToken];
        if (minutesNow >= lunch && minutesNow < dinner) {
            return "lunch";
        } else {
            return "dinner";
        }
    } else {
        if (minutesNow >= 16 * 60 || minutesNow < 2 * 60) {
            return "dinner";
        } else {
            return "lunch";
        }
    }
}

const formats = {
    isEven,
    shouldDisplayCta,
    shouldDisplayDishDetails,
    shouldDisplayDrinkDetails,
    shouldDisplayRestaurantCoverCharge,
    shouldDisplayPrice,
    shouldDisplayPayments,
    shouldDisplayPaymentsV2,
    shouldDisplayPaymentsButton,
    shouldDisplayPaymentsButtonV2,
    shouldDisplayFilterIcon,
    shouldDisplayIndecisiTab,
    capitalize,
    cleanPrice,
    formatPrice,
    formatUrl,
    formatIngredients,
    formatDrinkName,
    formatDescription,
    formatMotuekaDescription,
    truncate,
    getDayOfWeek,
    shiftTime,
    formatIsoTime,
    shouldShowList,
    shouldShowListBasedOnTimetables,
    getDeliveryRangeCost,
    setSearchedItems,
    formatGmapsStreet,
    formatPercentageToPrice,
    replacer,
    legacyFilterFormatter,
    chooseIconText,
    mcmUrl,
    loginUrl,
    shouldDisplayCustomBanner,
    generateRandomID,
    getConsumeTime
};
export default formats;
